export const EMPLOYEE = {
  LIST: '/pos/employees',
  CHECK_IN_OUT: '/pos/employees/check-in-out',
  CHECKED_IN_LIST: '/pos/employees/checked-in',
  ENABLE_BOOKING_LIST: '/pos/employees/enable-booking',
  ENABLE_WALKIN_LIST: '/pos/employees/enable-walkin',
};
